export default __webpack_public_path__ + "static/media/02.5195083a.jpg";